import Link from 'next/link';
import { FunctionComponent, useState } from 'react';

import styles from './NavBar.module.sass';
import { ParentItem } from '../common/types';
import NavDropDown from './NavDropDown';
import DisplayToggleBox from '../common/DisplayToggleBox';

export interface NavBarProps {
    navLinks: ParentItem[];
}

const NavBar: FunctionComponent<NavBarProps> = ({ navLinks, children }) => {
    const [activeDropdown, setActiveDropdown] = useState<string | null>(null);

    // id refers to an ID of the parent item
    const shouldToggleDropdown = (id: string | null) => () => setActiveDropdown(id);

    const linkComp = (item: ParentItem) => {
        const { text, path, subItems, newWin } = item;
        if (subItems) {
            return <span>{text}</span>;
        }
        if (newWin) {
            return (
                <a href={path} target="_blank" rel="noreferrer">
                    {text}
                </a>
            );
        }
        return (
            <Link href={path}>
                <a>{text}</a>
            </Link>
        );
    };

    const navLinkComps = navLinks.map((item) => {
        const { id, text, path, newWin, subItems } = item;
        return (
            <li key={id} className={styles.navLink} onMouseEnter={shouldToggleDropdown(id)}>
                {linkComp(item)}
                {subItems ? (
                    <DisplayToggleBox hidden={activeDropdown !== id}>
                        <NavDropDown items={subItems} onHide={shouldToggleDropdown(null)} />
                    </DisplayToggleBox>
                ) : null}
            </li>
        );
    });
    return (
        <nav className={styles.navbar}>
            <img className={styles.logo} src="/biz/logo.svg" alt="illustration" />
            <ul className={styles.menuGroup}>{navLinkComps}</ul>
            {children}
        </nav>
    );
};

export default NavBar;
